import { Link } from 'gatsby';
import DownloadsArticles from 'components/Downloads/Indoor_Cameras/IntroIndoorCams';
import NavButtons from 'components/Downloads/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  DownloadsArticles,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};